<template>

	<page>
		<title-view>מסך כרטיסים
            <v-btn slot="actions" color="success" @click="exportExcel">דו"ח כרטיסים</v-btn>
		</title-view>
		<row>
			<c-col>
				<cards-table />
			</c-col>
		</row>

	</page>


</template>

<script>
	import CardsTable from "src/views/cards/CardsTable";
	export default {
		name: "cards-view",
		components: {CardsTable},
		data() {
			return {
				openModal: false
			};
		},
        computed:{
            basicUrl() {
                return this.$store.state.ConfigModule.request.baseUrl;
            }
        },
        methods:{
		    exportExcel(){
                window.open(`${this.basicUrl}/card/export`);
            }
        }

	};
</script>

<style scoped>

</style>
